import React from 'react';
import { Card } from './ui/card';
import { mockTrustSignals } from '../utils/mock';
import { FileCheck, Target, Calendar, Users } from 'lucide-react';

const iconMap = {
  FileCheck: FileCheck,
  Target: Target,
  Calendar: Calendar,
  Users: Users
};

export const TrustSignals = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#7C2D12] mb-4">
              Trusted by Businesses Nationwide
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our track record speaks for itself. Join hundreds of satisfied clients who trust us to protect their most valuable asset.
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
            {mockTrustSignals.map((signal, index) => {
              const IconComponent = iconMap[signal.icon];
              
              return (
                <Card 
                  key={index}
                  className="p-8 bg-[#FFF7ED] border-2 border-[#FED7AA] hover:border-[#F97316] transition-all duration-300 hover:shadow-xl text-center group"
                >
                  <div className="bg-white w-16 h-16 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:bg-[#F97316] transition-colors duration-300">
                    <IconComponent className="text-[#F97316] group-hover:text-white transition-colors duration-300" size={32} />
                  </div>
                  
                  <div className="text-4xl font-bold text-[#7C2D12] mb-2">
                    {signal.number}
                  </div>
                  
                  <div className="text-gray-600 font-medium">
                    {signal.label}
                  </div>
                </Card>
              );
            })}
          </div>

          {/* Credentials Section */}
          <div className="grid md:grid-cols-3 gap-6">
            <Card className="p-6 bg-gradient-to-br from-[#7C2D12] to-[#F97316] border-0 text-center text-white">
              <div className="text-2xl font-bold mb-2">USPTO Filing Experts</div>
              <p className="text-white/90 text-sm">
                Registered attorneys with deep federal trademark law expertise
              </p>
            </Card>
            
            <Card className="p-6 bg-gradient-to-br from-[#7C2D12] to-[#F97316] border-0 text-center text-white">
              <div className="text-2xl font-bold mb-2">BBB Accredited</div>
              <p className="text-white/90 text-sm">
                Commitment to ethical business practices and client satisfaction
              </p>
            </Card>
            
            <Card className="p-6 bg-gradient-to-br from-[#7C2D12] to-[#F97316] border-0 text-center text-white">
              <div className="text-2xl font-bold mb-2">Money-Back Guarantee</div>
              <p className="text-white/90 text-sm">
                We stand behind our work with a satisfaction guarantee
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
